import { render, staticRenderFns } from "./AddPhysicalExamsToPrenatalConsultation.vue?vue&type=template&id=3fdb9e18&scoped=true"
import script from "./AddPhysicalExamsToPrenatalConsultation.vue?vue&type=script&lang=js"
export * from "./AddPhysicalExamsToPrenatalConsultation.vue?vue&type=script&lang=js"
import style0 from "./AddPhysicalExamsToPrenatalConsultation.vue?vue&type=style&index=0&id=3fdb9e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdb9e18",
  null
  
)

export default component.exports